enum Roles {
  CLIENT = "Client",
  REPRESENTATIVE = "Representant",
  ADMIN = "Admin",
}

export default Roles;
